import {create} from 'zustand'
import {MutableRefObject} from 'react'

interface State {
    modalRef?: MutableRefObject<any>
    setModalRef?: (modalRef: MutableRefObject<any>) => void
}

export const useInsufficientGasFeeModalStore = create<State>(set => ({
    setModalRef: (modalRef: MutableRefObject<any>) => set({modalRef}),
}))
